import React from 'react';
import styled from 'styled-components';
import LinkOutStroke from '@ad-scripts/presentation/components/common/icons/stroke/link-out-stroke';

const ExternalLink = ({
  'data-aid': dataAid,
  className,
  download,
  icon,
  label = 'Help Docs',
  showIcon = false,
  to,
}: {
  'data-aid'?: string;
  className?: string;
  download?: boolean;
  icon?: React.ReactNode;
  label?: string;
  showIcon?: boolean;
  to: string;
}): JSX.Element => {
  const iconElement = showIcon ? <Icon>{icon || <StyledLinkOutStroke />}</Icon> : null;

  return (
    <a className={className} target="_blank" data-aid={dataAid} rel="noopener noreferrer" href={to} download={download}>
      {label}
      {iconElement}
    </a>
  );
};

export const StyledExternalLink = styled(ExternalLink)`
  text-decoration: underline;
  color: ${p => p.theme.colors.black};
  display: inline-flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`;

const Icon = styled.span`
  svg {
    width: 16px;
    margin-left: 4px;
  }
`;

const StyledLinkOutStroke = styled(LinkOutStroke)`
  fill: ${p => p.theme.colors.gray800};
`;

export default ExternalLink;
